<template>
    <MainContainer>
        <div class="status">
            <h2>
                Status
                <b-button :size="size" @click="dataCreate">
                    Neu
                    <font-awesome-icon icon="plus" />
                </b-button>
            </h2>
            <Table
                bordered
                striped
                small
                showFilter
                :fields="fields"
                :items="items"
                :isBusy="busy"
                busyText="Lädt Status..."
                emptyText="Keine Status-Daten gefunden"
            >
                <template v-slot:chor="{ row: row }">
                    <template v-if="row.value == 1">
                        <font-awesome-icon icon="check" />
                    </template>
                    <template v-else>
                        <font-awesome-icon icon="times" />
                    </template>
                </template>

                <template v-slot:guest_singer="{ row: row }">
                    <template v-if="row.value == 1">
                        <font-awesome-icon icon="check" />
                    </template>
                    <template v-else>
                        <font-awesome-icon icon="times" />
                    </template>
                </template>

                <template v-slot:stimme="{ row: row }">{{
                    translateStimme(row.value)
                }}</template>

                <template v-slot:sp_schulen="{ row: row }">
                    <template v-if="row.value == 1">
                        <font-awesome-icon icon="check" />
                    </template>
                    <template v-else>
                        <font-awesome-icon icon="times" />
                    </template>
                </template>

                <template v-slot:actions="{ row: row }">
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        variant="link"
                        @click="dataSelected(row)"
                        class="mv-table-action-btn mr-1"
                        >Bearbeiten</b-button
                    >
                    <b-button
                        v-if="checkRight('delete')"
                        :size="size"
                        @click="dataDelete(row)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                        >Löschen</b-button
                    >
                </template>
            </Table>
            <EditModal
                :title="selected.title"
                :busy="selected.busy"
                buttonText="Speichern"
                scrollable
                @ok="dataProvide"
                @hide="dataHide"
            >
                <template v-if="selected.data">
                    <FormGroupBuilder
                        :fields="ioFields"
                        :data="selected.data"
                        :refresh="validationRefresh"
                    />
                </template>
            </EditModal>
            <RemoveModal
                :title="selected.title"
                :busy="selected.busy"
                @ok="dataProvide"
                @hide="dataHide"
            />
        </div>
    </MainContainer>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Validation from "@/mixins/Validation/Validation";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import EditModal from "@/components/EditModal/EditModal";
import RemoveModal from "@/components/RemoveModal/RemoveModal";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";

const StatusApi = ApiFactory.get("status");

export default {
    name: "Status",
    mixins: [CommonView, Size, Validation],
    components: {
        MainContainer,
        Table,
        EditModal,
        RemoveModal,
        FormGroupBuilder
    },
    data() {
        return {
            fields: [
                {
                    key: "value",
                    label: "Status",
                    sortable: true
                },
                {
                    key: "name",
                    label: "Bezeichnung",
                    sortable: true
                },
                /*{
                    key: "singer",
                    label: "Sänger*Innen",
                    sortable: true
                },*/
                {
                    key: "chor",
                    label: "Chor",
                    class: "text-center",
                    sortable: true
                },
                {
                    key: "stimme",
                    label: "Zugeordnete Stimme",
                    class: "text-center",
                    sortable: false
                },
                {
                    key: "guest_singer",
                    label: "Gast-Sänger*Innen",
                    class: "text-center",
                    sortable: true
                },
                {
                    key: "sp_schulen",
                    label: "SP-Schulen",
                    class: "text-center",
                    sortable: true
                },
                {
                    key: "actions",
                    label: "Funktionen",
                    class: "text-center"
                }
            ],
            ioFields: [
                {
                    key: "value",
                    label: "Status",
                    type: "text",
                    mandatory: true
                },
                {
                    key: "name",
                    label: "Bezeichnung",
                    type: "text",
                    mandatory: true
                },
                /*{
                    key: "singer",
                    label: "Sänger*Innen",
                    type: "checkbox",
                    checked_value: 1,
                    unchecked_value: 0,
                    description:
                        "Enthält dieser Status potentielle Sänger*Innen für kommende Werke?",
                    disabled: true
                },*/
                {
                    key: "chor",
                    label: "Chor",
                    type: "checkbox",
                    checked_value: 1,
                    unchecked_value: 0,
                    description:
                        "Enthält dieser Status grundsätzlich Chorteilnehmer (egal ob Chorleitung, Sänger*innen oder Mitarbeitende? Die Auswahl beeinflusst die Möglichkeit Auswahl von Mitglieder mit diesem Status innerhalb der Probenverwaltung",
                    disabled: false
                },
                {
                    key: "guest_singer",
                    label: "Gast-Sänger*Innen",
                    type: "checkbox",
                    checked_value: 1,
                    unchecked_value: 0,
                    description:
                        "Enthält dieser Status potentielle Gast-Sänger*Innen für kommende Werke? Die Auswahl beeinflusst die Möglichkeit Probenvergütungen für Mitglieder mit diesem Status anzulegen",
                    disabled: false
                },
                {
                    key: "stimme",
                    label: "Zugeordnete Stimme",
                    type: "select",
                    description:
                        "Die zugeordnete Stimme sorgt dafür, dass die Probenkontrolle die Mitglieder anhand Ihres Status den Stimme zuordnen kann",
                    options: [
                        { value: null, text: "Keine Zurodnung" },
                        { value: "sopran", text: "Sopran" },
                        { value: "tenor", text: "Tenor" },
                        { value: "alt", text: "Alt" },
                        { value: "bass", text: "Bass" }
                    ]
                },
                {
                    key: "sp_schulen",
                    label: "SingPause Schulen",
                    type: "checkbox",
                    checked_value: 1,
                    unchecked_value: 0,
                    description:
                        "Enthält dieser Status potentielle SingPause Schulen?",
                    disabled: false
                }
            ],
            api: StatusApi
        };
    },
    watch: {},
    methods: {
        translateStimme(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        fetchErrorHandling(response) {
            this.handleValidationData(response, this.ioFields);
        },
        postDataSet() {
            this.cleanValidationData(this.ioFields);
        }
    }
};
</script>
